export default {
  methods: {
    __(message) {
      const translations = window.icdsTranslates
      if(translations && translations[message]) {
        return translations[message]
      }
      return message
    }
  },
}
